import React from 'react'
import Loading from '../../../components/loading'
import Empty from '../../../components/empty'
import ConfirmButton from '../../../components/confirmbutton'
import Invoices from './components/invoices'
import Plans from './components/plans'
import {Table, Form, Message, Select, Image} from 'semantic-ui-react'
import {connect} from 'react-redux'
import {createAPIClient} from '../../../services/api'
const {Field, Button} = Form

class BillingSettings extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    const billingDetails = this.props.user.locations_data[0].billing
    const subscription = billingDetails && billingDetails.subscriptions[0]
    if (!billingDetails || !subscription) {
      return (
        <Empty />
      )
    }
    return (
      <div>
        <h2>Billing</h2>
        <Plans />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {locations: state.account.user.locations, user: state.account.user}
}

export default connect(mapStateToProps, {})(BillingSettings)



// WEBPACK FOOTER //
// ./src/pages/settings/billing/index.js